import React from "react";
import loadingImage from "../assets/Loading.png"; // Adjust path as needed

const LoadingImage = ({ width = "30rem", height = "30rem" }) => {
  return (
    <div className="flex justify-center items-center py-6">
      <img
        src={loadingImage}
        alt="Loading..."
        className={`object-contain mt-0 animate-pulse`}
        style={{ width, height }}
      />
    </div>
  );
};

export default LoadingImage;
